import { Layout, Menu, Button } from "antd";

import {
  DatabaseOutlined,
  DesktopOutlined,
  KeyOutlined,
  SettingOutlined,
  StarOutlined,
  UserOutlined,
  VideoCameraOutlined,
  TeamOutlined,
  PayCircleOutlined,
  PlusOutlined,
  CloudUploadOutlined,
  TrophyOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

import "./styles.css";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "../../router";

const { Sider } = Layout;
const { SubMenu } = Menu;

const SideNav = ({ updateTab }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/reels")) {
      setSelectedKeys(["manage-reels"]);
    }
  }, [location.pathname]);

  const manageContentEntries = [
    { key: "manage-movies", text: "Manage Movies" },
    { key: "manage-series", text: "Manage Series" },
    { key: "manage-vseries", text: "Manage Vertical Shorts" },
    { key: "manage-vepisodes", text: "Manage Vertical Episodes" },
    { key: "manage-episodes", text: "Manage Episodes" },
    { key: "manage-songs", text: "Manage Songs" },
    { key: "manage-reels", text: "Manage Reels", path: "/reels" },
  ];

  const masterDataEntries = [
    { key: "manage-artists", text: "Manage Artists" },
    { key: "manage-media-houses", text: "Manage Media Houses" },
    { key: "manage-genres", text: "Manage Genres" },
    { key: "manage-languages", text: "Manage Languages" },
    { key: "manage-plans", text: "Manage Plans" },
    { key: "manage-users", text: "Manage Users" },
  ];

  const featuredContentEntries = [
    { key: "banners", text: "Banners" },
    { key: "playlists", text: "Sections/Playlists" },
    { key: "Vplaylists", text: "Vertical Playlists" },
  ];

  const ordersTabEntries = [
    { key: "manage-orders", text: "Manage Orders" },
    { key: "manage-tickets", text: "Manage Tickets" },
    { key: "manage-discounts", text: "Manage Discounts" },
  ];

  const manageTasksEntries = [
    { key: "tasks-how-it-works", text: "How It Works" },
    { key: "series-coins", text: "Series Coins" },
    { key: "episode-coins", text: "Episode Coins" },
    { key: "unlock-config", text: "Unlock Config" },
    { key: "watch-earn-config", text: "Watch Earn Config" },
    { key: "watch-ladder-config", text: "Watch Ladder" },
    { key: "watch-campaign-config", text: "Watch Campaign" },
    { key: "episode-rewards-config", text: "Episode Rewards" },
    { key: "quiz-config", text: "Quiz & Earn" },
    { key: "quiz-app-config", text: "Quiz App (Reasoning)" },
    { key: "quiz-app-math", text: "Math App" },
    { key: "pubscale-ads", text: "PubScale Ads" },
    { key: "vcommission-offers", text: "vCommission Offers" },
  ];

  const reportsTabEntries = [
    { key: "user-reports", text: "User Reports" },
    { key: "churn-reports", text: "Churn Reports" },
    { key: "content-reports", text: "Content Reports" },
    { key: "like-reports", text: "Like Reports" },
    //{ key: "user-journey-reports-test", text: "User Journey Reports Test" },
    //{ key: "registration-to-subscription-reports", text: "Registration to Subscription Reports" },
    //{ key: "user-journey-reports", text: "User Journey Reports" },
    //{ key: "user-manadate-journey-reports", text: "User Mandate Journey Reports" },
    //{ key: "avg_content-episode-per-user", text: "Avg Content Episode Per User" },

    
  ];

  return (
    <Sider width={255} theme="light" className="side-nav-sider">
      <div className="side-nav-inner">
        <div className="side-nav-actions">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="nav-action-btn nav-action-primary"
            onClick={() => {
              navigate("/");
              updateTab("add-content");
              setSelectedKeys([]);
            }}
          >
            Add Content
          </Button>
          <Button
            icon={<CloudUploadOutlined />}
            className="nav-action-btn nav-action-secondary"
            onClick={() => {
              navigate("/");
              updateTab("upload-content");
              setSelectedKeys([]);
            }}
          >
            Upload Content
          </Button>
        </div>
        <div className="side-nav-scroll">
          <Menu
            mode="inline"
            defaultSelectedKeys={["dashboard"]}
            selectedKeys={selectedKeys}
            onSelect={(info) => setSelectedKeys(info.selectedKeys)}
            style={{ borderRight: 0 }}
          >
        <Menu.Item
          key="dashboard"
          icon={<DesktopOutlined />}
          onClick={() => {
            navigate("/");
            updateTab("dashboard");
            setSelectedKeys(["dashboard"]);
          }}
        >
          Dashboard
        </Menu.Item>
        <SubMenu
          key="content"
          title="Manage Content"
          icon={<VideoCameraOutlined />}
        >
          {manageContentEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                if (entry.path) {
                  navigate(entry.path);
                  updateTab(entry.key);
                } else {
                  navigate("/");
                  updateTab(entry.key);
                }
                setSelectedKeys([entry.key]);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <SubMenu key="data" title="Master Data" icon={<DatabaseOutlined />}>
          {masterDataEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                navigate("/");
                updateTab(entry.key);
                setSelectedKeys([entry.key]);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <SubMenu
          key="featured-content"
          title="Featured Content"
          icon={<StarOutlined />}
        >
          {featuredContentEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                navigate("/");
                updateTab(entry.key);
                setSelectedKeys([entry.key]);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <SubMenu key="orders" title="Orders" icon={<SettingOutlined />}>
          {ordersTabEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                navigate("/");
                updateTab(entry.key);
                setSelectedKeys([entry.key]);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <SubMenu key="reports" title="Reports" icon={<PayCircleOutlined />}>
          {reportsTabEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                navigate("/");
                updateTab(entry.key);
                setSelectedKeys([entry.key]);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <SubMenu key="manage-tasks" title="Manage Tasks" icon={<TrophyOutlined />}>
          {manageTasksEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                navigate("/");
                updateTab(entry.key);
                setSelectedKeys([entry.key]);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <Menu.Item
          key="login-integrity"
          icon={<SafetyCertificateOutlined />}
          onClick={() => {
            navigate("/");
            updateTab("login-integrity");
            setSelectedKeys(["login-integrity"]);
          }}
        >
          Login Integrity
        </Menu.Item>
        <Menu.Item
          key="app-config"
          icon={<SettingOutlined />}
          onClick={() => {
            navigate("/");
            updateTab("app-config");
            setSelectedKeys(["app-config"]);
          }}
        >
          Task Config
        </Menu.Item>
        <Menu.Item
          key="app-config-json"
          icon={<SettingOutlined />}
          onClick={() => {
            navigate("/");
            updateTab("app-config-json");
            setSelectedKeys(["app-config-json"]);
          }}
        >
          App Config JSON
        </Menu.Item>
        <Menu.Item
          key="employees"
          icon={<UserOutlined />}
          onClick={() => {
            navigate("/");
            updateTab("manage-employees");
            setSelectedKeys(["employees"]);
          }}
        >
          Manage Employees
        </Menu.Item>
        <Menu.Item
          key="partners"
          icon={<TeamOutlined />}
          onClick={() => {
            navigate("/");
            updateTab("manage-partners");
            setSelectedKeys(["partners"]);
          }}
        >
          Manage Partners
        </Menu.Item>
        <Menu.Item
          key="permissions"
          icon={<KeyOutlined />}
          onClick={() => {
            navigate("/");
            updateTab("manage-permissions");
            setSelectedKeys(["permissions"]);
          }}
        >
          Manage Permissions
        </Menu.Item>
          </Menu>
        </div>
      </div>
    </Sider>
  );
};

export default SideNav;
